'use client';

import { DatadogProvider as SharedDatadogProvider } from 'shared/context/DatadogContext';

// This provider initializes Datadog Browser RUM
// It only enables tracking in production environment and uses the shared context
export default function DatadogProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  // Pass environment variables as props to the shared provider
  // Environment variables don't change during runtime, so we don't need useMemo
  const config = {
    applicationId: process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID || '',
    clientToken: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN || '',
    enabled: process.env.NEXT_PUBLIC_DATADOG_ENABLED === 'true',
    env: process.env.NEXT_PUBLIC_DD_ENV || process.env.NODE_ENV || '',
    service: 'frontend',
    site: process.env.NEXT_PUBLIC_DATADOG_SITE || 'us5.datadoghq.com',
    version: process.env.NEXT_PUBLIC_DATADOG_VERSION || 'unknown',
    sessionSampleRate: Number(
      process.env.NEXT_PUBLIC_DD_SESSION_SAMPLE_RATE ?? '100',
    ),
    traceSampleRate: Number(
      process.env.NEXT_PUBLIC_DD_TRACE_SAMPLE_RATE ?? '100',
    ),
    allowedTracingUrls: process.env.NEXT_PUBLIC_BASE_URL
      ? [process.env.NEXT_PUBLIC_BASE_URL]
      : [],
  };

  return (
    <SharedDatadogProvider config={config}>{children}</SharedDatadogProvider>
  );
}
